import {startStars} from "./common-new";

export const mototabs = function (element) {
    this.element = element;
    const _this = this;
    this.init = function init() {
        const tab = element.find('.c-tabs__label-href.active');
        if(tab.length){
            _this.changeTab(tab);
        }
        element.find('.c-tabs__label-href:not(.active)').one('click',function () {
            _this.changeTab($(this));
        });
    }
    this.changeTab = function changeTab(tab) {
        const panel = $(tab.attr('href'));
        const url = tab.attr('data-href');
        $.ajax({
            url: url,
            dataType: 'json',
            success: function (data) {
                panel.removeClass('loading');
                panel.html(data.html);
                _this.initSlider(panel);
                startStars();
            }
        });
    }
    this.initSlider = function initSlider(element) {
        import('./swiper').then(module => {
            module.motoSwiper(element);
        });
    }
}